"use strict";

/**
 * @method FlixStats.modify() modify stats
 * @method FlixStats.increment() increment some value by 1
 */
;

var FlixStats = function () {
  // Send data to the endpoint on page/tab close
  window.addEventListener('pagehide', send); // Call "onPageLoad" when page loaded and "Flix" object prepared

  document.addEventListener('flix:load:first', onPageLoadFirst); // Core data like page start, end, url, etc

  var data = {}; // External stats modified via FlixStats.increment()

  var stats = {};
  var sent = false;
  /**
   * @returns {string}
   */

  function getEndpoint() {
    return FlixUtils.isLocalEnv() ? '/local/traffic' : 'https://ac2.tnaflix.com/traffic.php';
  }
  /**
   * Do stuff on the page load
   */


  function onPageLoadFirst() {
    return; // disabled for now
    // Check if data is not empty, send it and reset (for SPA)

    send();
    data = getInitialData();
    stats = {};
    sent = false;
  }
  /**
   * Send data on closing tab
   */


  function send() {
    return; // disabled for now

    if (sent || Object.keys(data).length === 0) {
      return; // do nothing if there is no data
    }

    sent = true; // final updates on "data"

    data.time_end = Math.floor(new Date().getTime() / 1000);
    data.time_duration = data.time_end - data.time_start;
    data.stats = stats;
    var fd = new FormData();
    fd.append('data', JSON.stringify(data));

    if (typeof navigator.sendBeacon !== 'function' || !navigator.sendBeacon(getEndpoint(), fd)) {
      // Fallback if beacon is not supported
      var xhr = new XMLHttpRequest();
      xhr.open("POST", getEndpoint(), false);
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.send(JSON.stringify(data));
    }

    data = getInitialData();
    stats = {};
    sent = false;
  }
  /**
   * Return initial data object
   * @returns {object}
   */


  function getInitialData() {
    var _window$referrer_fall, _URLSearchParams$get;

    data = {};
    data.adblock = Flix.ads.adblock();
    data.time_start = Math.floor(new Date().getTime() / 1000);
    data.url = window.location.href;
    data.ref_url = (_window$referrer_fall = window['referrer_fallback']) !== null && _window$referrer_fall !== void 0 ? _window$referrer_fall : document.referrer;
    data.ref_host = data.ref_url ? new URL(data.ref_url).host : '';

    if (sessionStorage.getItem('_ftrf_pgnum')) {
      var _n = parseInt(sessionStorage.getItem('_ftrf_pgnum'));

      _n = isNaN(_n) ? 0 : _n;
      data.page_num = ++_n;
    } else {
      data.page_num = 1;
    }

    sessionStorage.setItem('_ftrf_pgnum', data.page_num);
    data.route_id = Flix.currentRouteId;

    switch (Flix.currentRouteId) {
      case 'controllers.video.view':
        data.route_arg = Flix.routeArgs.vid;
        break;

      case 'controllers.video.category':
        data.route_arg = Flix.routeArgs.categorySlug;
        break;

      case 'controllers.channel.view':
        data.route_arg = Flix.routeArgs.slug;
        break;

      case 'controllers.profile.view':
        data.route_arg = Flix.routeArgs.username;
        break;

      case 'controllers.video.search':
        data.route_arg = (_URLSearchParams$get = new URLSearchParams(window.location.search).get('what')) === null || _URLSearchParams$get === void 0 ? void 0 : _URLSearchParams$get.toLowerCase();
        break;

      default:
        data.route_arg = '';
        break;
    }

    return data;
  }
  /**
   * For example: FlixStats.increment('error_external')
   * 
   * @param {string} key 
   */


  function increment(key) {
    if (stats['counts'] === undefined) {
      stats['counts'] = {};
    }

    stats['counts'][key] = (stats['counts'][key] || 0) + 1;
  }
  /**
   * ```js
   * FlixStats.modify('fatigue', (obj) => {
   *      // some object modifications
   * 
   *      return obj;
   * });
   * ```
   * 
   * @param {string} key 
   * @param {callback} cb 
   */


  function modify(key, cb) {
    stats[key] = cb(stats[key]);
  }

  return {
    increment: increment,
    modify: modify
  };
}();